<template>
    <v-container>
        <center>
            <v-img
                aspect-ratio="1"
                src="/assets/empty.png"
                height="250px"
                contain
                ></v-img>
            <p class="subheading desMax grey--text" v-if="description">{{description}}</p>
            <slot></slot>
        </center>
    </v-container>
</template>

<script>
export default {
    name: "VEmpty",
    props: {
        description: String,
    }

}
</script>

<style scoped>
    .desMax {
        max-width: 400px;
    }
    .img {
        width: 100%;
    }
</style>
